export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1400px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',
	moduleMark:
		'inline-flex h-[36px] w-[36px] items-center justify-center rounded-lg border border-purple-100 bg-purple-50 text-purple-700 shrink-0',
	tableHeader: 'text-[10px] font-medium uppercase tracking-wider text-subtle',
	tag: 'inline-flex items-center rounded border border-subtle bg-grey-25 px-3xs py-3xs text-[10px] font-mono leading-none text-default',
	costMain: 'font-semibold text-default tabular-nums',
	costBrand: 'font-semibold text-purple-700 tabular-nums',
	costDeltaFlat: 'text-[10px] text-subtle tabular-nums',
	statusActive: 'inline-flex items-center gap-3xs text-[12px] text-default',
	statusDegraded: 'inline-flex items-center gap-3xs text-[12px] text-amber-700',
	statusDown: 'inline-flex items-center gap-3xs text-[12px] text-red-700',
	statusMuted: 'inline-flex items-center gap-3xs text-[12px] text-subtle',
	dotSuccess: 'inline-block h-2xs w-2xs rounded-full bg-green-500',
	dotWarn: 'inline-block h-2xs w-2xs rounded-full bg-amber-500',
	dotDown: 'inline-block h-2xs w-2xs rounded-full bg-red-500',
	dotMuted: 'inline-block h-2xs w-2xs rounded-full bg-grey-400',
	reference: 'flex items-start gap-xs rounded-lg border border-subtle bg-grey-25/50 px-md py-sm',
};
